import { type RecordSourceProxy } from 'relay-runtime';

// While a Relay-native optimistic layer is being applied (inside commitMutation's
// `optimisticUpdater`/`updater`), the caller's Apollo-style `update` callback runs and issues
// interop cache writes (writeQueryInterop / writeFragmentInterop). Those writes must land on the
// store proxy Relay handed us — the optimistic layer — rather than committing permanently to the
// base store. We expose the active proxy here as ambient state (mirroring how Apollo runs `update`
// against its optimistic-layer cache proxy) so the interop write functions can detect it and route
// onto the layer. Outside an updater this is null and writes keep their normal permanent path.
let ambientStoreProxy: RecordSourceProxy | null = null;

export function runWithAmbientStoreProxy<T>(store: RecordSourceProxy, run: () => T): T {
	const previous = ambientStoreProxy;
	ambientStoreProxy = store;
	try {
		return run();
	} finally {
		ambientStoreProxy = previous;
	}
}

export function getAmbientStoreProxy(): RecordSourceProxy | null {
	return ambientStoreProxy;
}
